var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_814_252)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.43723 1.97363H13.7928C14.4095 1.97363 14.9658 2.23141 15.3709 2.64261C15.7759 3.05382 16.0299 3.61847 16.0299 4.24448V5.92H18.5753C19.192 5.92 19.7482 6.17778 20.1533 6.58285C20.5584 6.99406 20.8123 7.5587 20.8123 8.18472V19.6494C20.8123 20.2755 20.5644 20.8401 20.1533 21.2513C19.7482 21.6625 19.192 21.9203 18.5753 21.9203H10.2136C9.5969 21.9203 9.04066 21.6687 8.63558 21.2513C8.23049 20.834 7.98261 20.2755 7.98261 19.6494V17.9739H5.43723C4.82053 17.9739 4.2643 17.7162 3.85921 17.3049C3.45413 16.8937 3.2002 16.3352 3.2002 15.7092V4.24448C3.2002 3.61847 3.44808 3.05382 3.85921 2.64261C4.25825 2.23141 4.82053 1.97363 5.43723 1.97363ZM16.0238 7.25797V15.7092C16.0238 16.3352 15.7759 16.8999 15.3648 17.3111C14.9597 17.7223 14.4035 17.9739 13.7868 17.9739H9.2946V19.6494C9.2946 19.9072 9.39738 20.1404 9.56667 20.3062C9.73596 20.478 9.96571 20.5823 10.2136 20.5823H18.5692C18.8231 20.5823 19.0529 20.478 19.2161 20.3062C19.3854 20.1343 19.4882 19.9072 19.4882 19.6494V8.19086C19.4882 7.93308 19.3854 7.706 19.2161 7.53415C19.0468 7.3623 18.8231 7.25797 18.5692 7.25797H16.0238ZM13.7868 3.31159H5.43723C5.18329 3.31159 4.95959 3.41593 4.7903 3.58778C4.62101 3.75963 4.51823 3.98671 4.51823 4.24448V15.7092C4.51823 15.967 4.62101 16.1941 4.7903 16.3659C4.95959 16.5378 5.18934 16.6421 5.43723 16.6421H8.64162H13.7868C14.0407 16.6421 14.2644 16.5378 14.4337 16.3659C14.603 16.1941 14.7058 15.967 14.7058 15.7092V6.58898V4.24448C14.7058 3.98671 14.603 3.75963 14.4337 3.58778C14.2705 3.41593 14.0407 3.31159 13.7868 3.31159Z",
    fill: "#565656"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_814_252"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.6,
    height: 19.9467,
    fill: "white",
    transform: "translate(3.2002 1.97363)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copyIcon.67c3348f.svg";
export { ForwardRef as ReactComponent };